import React from "react";
import { getNumber, getCommaNumber } from "utils/format";

import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import Chart from "chart.js/auto";
Chart.register(ChartDataLabels);

export const BarChart = (props) => {
  if (!props.data || !props.data.labels) return null;

  const getFontInfo = (size, weight, color) => {
    return {
      size: size ? size : 12,
      weight: weight ? weight : "normal",
      family: "Pretendard",
    };
  };

  const getNumberInfo = (value) => {
    if (!value) return "없음";

    let isNegative = value < 0;
    let unit, unitAmount;
    value = Math.abs(getNumber(value));

    switch (true) {
      case value < 10000000:
        unit = "만";
        unitAmount = 10000;
        break;
      case value < 100000000:
        unit = "천만";
        unitAmount = 10000000;
        break;
      case value < 100000000000:
        unit = "억";
        unitAmount = 100000000;
        break;
      default:
        unit = "조";
        unitAmount = 100000000000;
    }
    value = (value / unitAmount).toFixed(1);
    return getCommaNumber(value * (isNegative ? -1 : 1)) + unit;
  };

  const options = {
    plugins: {
      legend: {
        display: props.isLegend ? props.isLegend : false,
        position: "bottom",
        labels: {
          boxWidth: 8,
          boxHeight: 8,
          padding: 15,
          usePointStyle: true,
          font: getFontInfo(14, 700),
        },
      },
      tooltip: {
        enabled: true,
        displayColors: false,
        callbacks: {
          title: (content) => {},
          label: (context) => {
            const label = context.dataset.label || "";
            return context.formattedValue + "원";
          },
        },
        xAlign: "center",
        yAlign: "bottom",
      },
      datalabels: {
        formatter: (value, ctx) => {
          const datasets = ctx.chart.data.datasets;
          if (ctx.datasetIndex == datasets.length - 1) {
            let sum = 0;
            datasets.map((dataset) => {
              sum += dataset.data[ctx.dataIndex] || 0;
            });
            return getNumberInfo(sum);
          } else {
            return "";
          }
        },
        color: (context) => {
          const index = context.dataIndex;
          const lastIndex = context.dataset.data.length - 1;
          return index == lastIndex ? "#004fec" : "#70747d";
        },
        align: "end",
        anchor: "end",
        font: getFontInfo(12, 700),
        padding: {
          bottom: -5,
        },
      },
    },
    layout: {
      padding: {
        left: -10,
        right: 0,
        bottom: 0,
        top: 30,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    scaleShowLabels: false,
    scales: {
      x: {
        stacked: true,
        grid: {
          display: false,
          drawBorder: false,
          offset: true,
        },
        ticks: {
          display: true,
          padding: 0,
          beginAtZero: true,
          font: getFontInfo(null, 600),
          color: "transparent",
        },
      },
      y: {
        stacked: true,
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          display: false,
          padding: 0,
          beginAtZero: true,
        },
      },
    },
    hover: {
      animationDuration: 0,
    },
    animation: {
      duration: 0,
    },
  };

  const plugins = [
    {
      afterDatasetsDraw(chart) {
        const ctx = chart.ctx;
        const xAxis = chart.scales.x;
        const yAxis = chart.scales.y;
        ctx.save();
        const lastIndex = chart.data.labels.length - 1;
        chart.data.labels.forEach((item, index) => {
          const x = xAxis.getPixelForValue(item);
          if (typeof item == "string") item = [item];
          const isLast = lastIndex == index;
          ctx.textAlign = "center";
          if (item[0]) {
            ctx.font = "600 14px Pretendard";
            ctx.fillStyle = isLast ? "#004fec" : "#70747d";
            ctx.fillText(item[0], x, yAxis.bottom + 18);
          }
          if (item[1]) {
            ctx.font = "400 14px Pretendard";
            ctx.fillStyle = isLast ? "#004fec" : "#9a9ea8";
            ctx.fillText(item[1], x, yAxis.bottom + 35);
          }
        });
        ctx.restore();
      },
    },
  ];

  return (
    <Bar
      data={props.data}
      height={props.height}
      options={options}
      plugins={plugins}
    />
  );
};

export default BarChart;
